import { MainColor } from '../../palette/colors';

export const getFormStepperThemeConfig = () => {
  return {
    steps: {
      successColor: 'forest50' as MainColor,
      defaultColor: 'coolGrey30' as MainColor,
    },
    header: {
      subHeader: {
        color: 'coolGrey60' as MainColor,
      },
    },
  };
};

export type FormStepperTheme = ReturnType<typeof getFormStepperThemeConfig>;
